import { render, staticRenderFns } from "./deposito_representante.vue?vue&type=template&id=7572212f&"
import script from "./deposito_representante.vue?vue&type=script&lang=js&"
export * from "./deposito_representante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports